import { ReplyTemplateModel, RequestModel, ResponseModel } from '@models/index'
import { createAction, props } from '@ngrx/store'


export const saveReplyTemplate = createAction(
    '[ReplyTemlate] Save reply template',
    props<{ request: RequestModel }>()
)

export const saveReplyTemplateSuccess = createAction(
    '[ReplyTemlate] Save reply template success',
    props<{ response: ReplyTemplateModel }>()
)

export const getReplyTemplate = createAction(
    '[ReplyTemlate] Get reply template',
    props<{ request: RequestModel }>()
)

export const getReplyTemplateSuccess = createAction(
    '[ReplyTemlate] Get reply template success',
    props<{ response: ReplyTemplateModel }>()
)

export const setReplyTemplate = createAction(
    '[ReplyTemlate] Set reply template',
    props<{ text: string }>()
)